import type { MapLayer, MapLayerFormat } from '@/types/layers';
import type { MapLayerDto } from '@/types/api/responses/layers';

/**
 * Maps a layer API response DTO to a frontend MapLayer domain model.
 */
export function mapLayerFromApi(dto: MapLayerDto): MapLayer {
  return {
    id: dto.id,
    name: dto.name,
    description: dto.description,
    sourceFormat: dto.sourceFormat as MapLayerFormat,
    fileSizeBytes: dto.fileSizeBytes,
    featureCount: dto.featureCount,
    boundsJson: dto.boundsJson,
    sortOrder: dto.sortOrder,
    isVisible: dto.isVisible,
    styleJson: dto.styleJson,
    uploadedBy: dto.uploadedBy,
    uploaderName: dto.uploaderName,
    createdAt: new Date(dto.createdAt),
    updatedAt: dto.updatedAt ? new Date(dto.updatedAt) : null,
  };
}
